<template>
  <div class="card card-custom gutter-b">
    <div class="card-header">
      <div class="card-title">
        <div class="symbol symbol-40 mr-2 text-center">
          <img
            class="mx-auto"
            :alt="destinationTypes[destination.type]"
            :src="
              `/media/destinations/${destinationTypes[destination.type]}.png`
            "
          />
        </div>
        <h3 class="card-label">
          {{ destination.name }}
        </h3>
      </div>
      <div class="card-toolbar">
        <span class="font-family-base" dir="ltr">
          {{ formatDate(destination.updated_at) }}
        </span>
      </div>
    </div>
    <div class="card-body">
      <form id="form">
        <!-- <div class="form-group">
          <label class="checkbox mb-0">
            <input
              type="checkbox"
              name="comment_status"
              true-value="2"
              false-value="1"
              v-model="form.details.comment_status"
            />
            <span class="mr-2"></span>
            فعالسازی دیدگاه‌ها
          </label>
        </div> -->
        <div class="form-group">
          <label class="checkbox mb-0">
            <input
              type="checkbox"
              name="rotation"
              true-value="90"
              false-value="0"
              v-model="form.rotation"
            />
            <span class="mr-2"></span>
            چرخش ۹۰ درجه
          </label>
        </div>
        <div class="form-group">
          <label class="checkbox mb-0">
            <input
              type="checkbox"
              name="proxy_status"
              true-value="1"
              false-value="2"
              v-model="form.proxy_status"
            />
            <span class="mr-2"></span>
            استفاده از پروکسی
          </label>
        </div>
        <div class="form-group">
          <label class="checkbox mb-0">
            <input
              type="checkbox"
              name="auto_connect"
              true-value="1"
              false-value="0"
              v-model="form.auto_connect"
            />
            <span class="mr-2"></span>
            اتصال خودکار
          </label>
        </div>
        <div class="form-group" v-if="isAdmin || isCompany">
          <label class="checkbox mb-0">
            <input
              type="checkbox"
              name="editable"
              true-value="1"
              false-value="0"
              v-model="form.editable"
            />
            <span class="mr-2"></span>
            فابلیت وبرایش و حدف توسط کاربر
          </label>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import _ from "lodash";

export default {
  name: "EdInstagramDestination",
  props: {
    isCompany: Boolean,
    isAdmin: Boolean
  },
  data() {
    return {
      changed: false,
      form: {},
      showPassword: false
    };
  },
  beforeMount() {
    this.form = _.cloneDeep(this.originalForm);
  },
  mounted() {
    this.fv = formValidation(document.getElementById("form"), {
      fields: {},
      plugins: {
        trigger: new Trigger(),
        bootstrap: new Bootstrap()
      }
    });
  },
  watch: {
    originalForm: {
      handler() {
        this.form = _.cloneDeep(this.originalForm);
      },
      deep: true
    },

    form: {
      handler() {
        this.$emit("change-form", _.isEqual(this.form, this.originalForm));
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(["destinationTypes", "destination"]),
    originalForm() {
      return {
        id: this.destination.id,
        name: this.destination.name,
        details: {
          username: this.destination.details.username.toString(),
          comment_status: this.destination.details.comment_status.toString()
        },
        rotation: this.destination.rotation.toString(),
        proxy_status: this.destination.proxy_status.toString(),
        editable: this.destination.editable.toString(),
        auto_connect: this.destination.auto_connect.toString()
      };
    }
  }
};
</script>
